import { bufferType, attributeId } from "_src/engine/constants";

function getAttributeNameByID(id) {

  switch(id) {
    case attributeId.POSITION:
      return "a_position";
    case attributeId.POSITION2D:
      return "a_position2d";
    case attributeId.INDICES_32:
    case attributeId.INDICES_16:
    case attributeId.INDICES_8:
      return "indices";
    case attributeId.EDGES_INDICES_32:
    case attributeId.EDGES_INDICES_16:
    case attributeId.EDGES_INDICES_8:
      return "edges_indices";
    case attributeId.NORMAL:
      return "a_normal";
    case attributeId.UV:
      return "a_uv";
    case attributeId.COLOR:
      return "a_color";
    case attributeId.DISTANCE:
      return "a_distance";
    case attributeId.SIZE:
      return "a_size";
    case attributeId.FIT_MASK:
      return "fit_mask";
    case attributeId.OLD_INDICES:
      return "old_indices";
  }

  return null;

}

function getTypedArrayByID(id) {

  switch(id) {
    case attributeId.POSITION:
    case attributeId.POSITION2D:
    case attributeId.NORMAL:
    case attributeId.UV:
    case attributeId.DISTANCE:
    case attributeId.SIZE:
      return Float32Array;
    case attributeId.INDICES_32:
    case attributeId.EDGES_INDICES_32:
    case attributeId.OLD_INDICES:
      return Uint32Array;
    case attributeId.INDICES_16:
    case attributeId.EDGES_INDICES_16:
      return Uint16Array;
    case attributeId.COLOR:
    case attributeId.INDICES_8:
    case attributeId.EDGES_INDICES_8:
    case attributeId.FIT_MASK:
      return Uint8Array;
  }

  return null;

}

function getTypeByID(id) {

  switch(id) {
    case attributeId.POSITION:
    case attributeId.NORMAL:
      return bufferType.F32_3;
    case attributeId.INDICES_32:
      return bufferType.UI32_3;
    case attributeId.POSITION2D:
    case attributeId.UV:
      return bufferType.F32_2;
    case attributeId.COLOR:
      return bufferType.UI8_4;
    case attributeId.INDICES_16:
      return bufferType.UI16_3;
    case attributeId.INDICES_8:
      return bufferType.UI8_3;
    case attributeId.DISTANCE:
    case attributeId.SIZE:
      return bufferType.F32_1;
    case attributeId.FIT_MASK:
      return bufferType.UI8_1;
    case attributeId.EDGES_INDICES_32:
      return bufferType.UI32_2;
    case attributeId.EDGES_INDICES_16:
      return bufferType.UI16_2;
    case attributeId.EDGES_INDICES_8:
      return bufferType.UI8_2;
    case attributeId.OLD_INDICES:
      return bufferType.UI32_1;
  }

  return null;

}

function getAttributeIDByName(name, typedArray) {

  switch(name) {
    case "a_position":
      return attributeId.POSITION;
    case "a_position2d":
      return attributeId.POSITION2D;
    case "indices":
      if (typedArray instanceof Uint32Array) {
        return attributeId.INDICES_32;
      } else if (typedArray instanceof Uint16Array) {
        return attributeId.INDICES_16;
      } else {
        return attributeId.INDICES_8;
      }
    case "edges_indices":
      if (typedArray instanceof Uint32Array) {
        return attributeId.EDGES_INDICES_32;
      } else if (typedArray instanceof Uint16Array) {
        return attributeId.EDGES_INDICES_16;
      } else {
        return attributeId.EDGES_INDICES_8;
      }
    case "a_normal":
      return attributeId.NORMAL;
    case "a_uv":
      return attributeId.UV;
    case "a_color":
      return attributeId.COLOR;
    case "a_distance":
      return attributeId.DISTANCE;
    case "a_size":
      return attributeId.SIZE;
    case "fit_mask":
      return attributeId.FIT_MASK;
    case "old_indices":
      return attributeId.OLD_INDICES;
  }

  return null;

}

function checkDegenerateTriangle(v1, v2, v3) {
  return v1 == v2 || v2 == v3 || v3 == v1;
}

const DEFAULT_ATTRIBUTES = ["a_position", "indices", "a_normal", "a_uv", "a_color", "a_size", "a_distance", "fit_mask", "edges_indices", "old_indices"];
const DEFAULT_NO_INDICES_ATTRIBUTES = ["a_position", "a_normal", "a_uv", "a_color", "a_size", "a_distance", "fit_mask"];

export { getAttributeNameByID, getTypedArrayByID, getTypeByID,
        getAttributeIDByName, DEFAULT_ATTRIBUTES, DEFAULT_NO_INDICES_ATTRIBUTES, checkDegenerateTriangle };
